import * as React from "react";

export function EmailVerificationPage(): JSX.Element {
  return (
    <div className="p-6">
      <h1 className="text-xl font-medium mb-2">Verify Your Email</h1>
      <p className="text-sm text-muted-foreground">We sent a verification link to your inbox.</p>
    </div>
  );
}

